import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import LoginPage from '../pages/LoginPage'
import { useAuth } from '@/auth/AuthProvider'
import { getEntryPathForUser, isApiEnabled } from '@/routes/role-routing'
import MeseroRoot from '@/modules/mesero/pages/MeseroRoot'
import MesasPage from '@/modules/mesero/pages/MesasPage'
import ComandaPage from '@/modules/mesero/pages/ComandaPage'
import MesaItemsPage from '@/modules/mesero/pages/MesaItemsPage'
import AlertasPage from '@/modules/mesero/pages/AlertasPage'
import ReservasPage from '@/modules/mesero/pages/ReservasPage'
import VentasPage from '@/modules/caja/pages/VentasPage'
import AdminPage from '@/modules/admin/pages/AdminPage'
import CocinaPage from '@/modules/estaciones/cocina/pages/CocinaPage'
import BarPage from '@/modules/estaciones/bar/pages/BarPage'
import RetiroPage from '@/modules/estaciones/retiro/pages/RetiroPage'
import DeliveryPage from '@/modules/estaciones/delivery/pages/DeliveryPage'

function RequireAuth() {
  const { status, isAuthenticated } = useAuth()
  if (!isApiEnabled()) return <Outlet />
  if (status === 'loading') return null
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <Outlet />
}

function RequireRole({ allow }: { allow: string[] }) {
  const { status, isAuthenticated, user } = useAuth()
  if (!isApiEnabled()) return <Outlet />
  if (status === 'loading') return null
  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (user && allow.includes(user.role)) return <Outlet />
  if (user && user.role === 'admin') return <Outlet />
  return <Navigate to={getEntryPathForUser(user)} replace />
}

function EntryLanding() {
  const { status, isAuthenticated, user } = useAuth()
  if (!isApiEnabled()) return <Navigate to="/mesero/mesas" replace />
  if (status === 'loading') return null
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <Navigate to={getEntryPathForUser(user)} replace />
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route path="/" element={<EntryLanding />} />

        <Route path="/mesero" element={<RequireRole allow={['waiter']} />}>
          <Route element={<MeseroRoot />}>
            <Route index element={<Navigate to="mesas" replace />} />
            <Route path="mesas" element={<MesasPage />} />
            <Route path="comanda/:tableId" element={<ComandaPage />} />
            <Route path="mesa/:tableId/items" element={<MesaItemsPage />} />
            <Route path="alertas" element={<AlertasPage />} />
            <Route path="reservas" element={<ReservasPage />} />
          </Route>
        </Route>

        <Route path="/caja" element={<RequireRole allow={['cashier']} />}>
          <Route index element={<Navigate to="ventas" replace />} />
          <Route path="ventas" element={<VentasPage />} />
          <Route path="pagos" element={<VentasPage />} />
        </Route>

        <Route path="/admin" element={<RequireRole allow={['admin', 'auditor']} />}>
          <Route index element={<AdminPage />} />
        </Route>

        <Route path="/station" element={<RequireRole allow={['kitchen']} />}>
          <Route index element={<Navigate to="cocina" replace />} />
          <Route path="cocina" element={<CocinaPage />} />
          <Route path="bar" element={<BarPage />} />
          <Route path="retiro" element={<RetiroPage />} />
          <Route path="delivery" element={<DeliveryPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
